import ReadingDetailsForm from '../reporting/ReadingDetailsForm';

const hasDetails = (details = {}) => Object.values(details).some(
  (value) => (Array.isArray(value) ? value.length > 0 : Boolean(value))
);

/** Notes and reading details for one report, opened under its row. */
const ReportEditPanel = ({ report, editing, onChange, onSave, onCancel, onDelete }) => {
  const notesId = `report-notes-${report.id}`;

  return (
    <div className="report-edit-panel">
      <div className="report-edit-notes">
        <label htmlFor={notesId}>Notes</label>
        <textarea
          id={notesId}
          value={editing.notes}
          onChange={(e) => onChange({ ...editing, notes: e.target.value })}
          maxLength={1000}
          rows={3}
          placeholder="Add notes about this reading..."
        />
      </div>

      {/* Closed unless this report already has details, to keep the panel short. */}
      <details className="report-edit-more" open={hasDetails(editing.readingDetails)}>
        <summary>Reading details</summary>
        <ReadingDetailsForm
          formData={editing.readingDetails}
          onChange={(details) => onChange({ ...editing, readingDetails: details })}
          showDetails={true}
          onToggleDetails={() => {}}
          compact={true}
        />
      </details>

      <div className="report-edit-actions">
        <button type="button" className="report-delete-link" onClick={() => onDelete(report.id)}>
          Delete
        </button>
        <span className="report-edit-actions-end">
          <button type="button" className="report-btn" onClick={onCancel}>Cancel</button>
          <button type="button" className="report-btn report-btn--primary" onClick={onSave}>Save</button>
        </span>
      </div>
    </div>
  );
};

export default ReportEditPanel;
